module.exports = __webpack_public_path__ + "static/media/poster2.73f182f2.jpg";